/* eslint-disable */
import React, { useContext, useState } from 'react';
import { Grid, Paper, TextField, Button, Typography } from '@mui/material';
import { AuthContext } from '../../contexts/authContext';
import { useValidEmail } from '../../hooks/useValidEmail';
import { useNavigate, Link } from 'react-router-dom';
import {
  forgotHeaderStyle,
  inputStyle,
  paperStyle,
  pLabelStyle,
  TypographyStyle,
} from '../styles';
import { IconButton, InputAdornment, Snackbar } from '@mui/material';
import { PasswordType } from '../../interfaces/IPassType';
import { AuthPAGES } from '../../constants/pages';
import { MuiButton } from '../../components/Button/Button';
import { Header } from '../../components/Header/Header';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

const ForgotPasswordEmail: React.FC = () => {
  /* States and context declaration */
  const { email, setEmail, emailIsValid } = useValidEmail(null);
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [genericErrorMessage, setGenericErrorMessage] = useState('');

  const validateEmail = async (email: string) => {
    try {
      await authContext.signInWithEmail(email, 'MyTesingPass%^945');
      return false;
    } catch (error: any) {
      console.log(error.code);
      if (error.code === 'UserNotFoundException') {
        return true;
      } else {
        return false;
      }
    }
  };

  const onRecoverPressed = async (e: any) => {
    e.stopPropagation();
    if (email) {
      try {
        const validation = await validateEmail(email);
        if (!validation) {
          await authContext.sendCodeRecoverPassword(email);
          authContext.setEmail(email);
          navigate(`${AuthPAGES.checkPassword}/${PasswordType.RECOVERY}`);
        } else {
          setGenericErrorMessage('Account not found');
          setOpen(true);
        }
      } catch (error: any) {
        // setGenericErrorMessage(error.message);
        setGenericErrorMessage('This email does not exist in our system');
        setOpen(true);
      }
    }
  };

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const isButtonDisabled = () => {
    return emailIsValid !== '' || email === null || email === '';
  };

  const action = (
    <React.Fragment>
      <Button style={{ color: 'white' }} size='small' onClick={handleClose}>
        Close
      </Button>
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={handleClose}
      ></IconButton>
    </React.Fragment>
  );

  return (
    <Grid container justifyContent='center' alignContent='center'>
      <Grid item xl={4} lg={4} md={6} sm={10} xs={11}>
        <Paper
          elevation={0}
          style={paperStyle}
          className='responsive-paper-style'
        >
          <Grid style={forgotHeaderStyle}>
            <Header
              text1='Forgot Your Password?'
              text2='Enter your email to start'
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <TextField
              id='outlined-adornment-email'
              size='small'
              variant='outlined'
              fullWidth
              style={{ ...inputStyle, marginTop: '0' }}
              type='text'
              value={email}
              error={emailIsValid !== '' || genericErrorMessage !== ''}
              helperText={emailIsValid}
              onChange={(e: any) => setEmail(e.target.value)}
              label='E-mail'
              InputProps={{
                style: {
                  borderRadius: '50px',
                  color: genericErrorMessage !== '' ? 'red' : '',
                },
                startAdornment: (
                  <InputAdornment position='start'>
                    <EmailOutlinedIcon
                      style={{
                        color: genericErrorMessage !== '' ? 'red' : '#227BEF',
                        width: '20px',
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12} style={{ marginTop: '32px' }}>
            <MuiButton
              loading={false}
              disabled={isButtonDisabled()}
              onSubmit={onRecoverPressed}
              text='Continue'
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <Typography style={TypographyStyle}>
              <Link style={pLabelStyle} to={AuthPAGES.signIn}>
                Back to Login
              </Link>
            </Typography>
          </Grid>
        </Paper>
      </Grid>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        message={genericErrorMessage}
        action={action}
      />
    </Grid>
  );
};

export default ForgotPasswordEmail;
